export default "__VITE_PUBLIC_ASSET__bd3eac34__"